<div class="row">
    <!-- Page Heading and Buttons -->
    <div class="col-6">
        <h2>{{buttonTitle}}</h2>
    </div>
    <div class="col-6 text-right">
        <button type="submit" style="float: right" class="btn btn-primary px-4" (click)="onBack()">
            Back
        </button>
        <button type="submit" (click)="onSubmit()" style="float: right; margin-right: 20px"
            class="btn btn-primary px-4">
            Save
        </button>
    </div>
</div>

<div class="col-12 mt-4">
    <nb-card class="custom-card">
        <nb-card-body style="position: relative">
            <form>
                <!-- Holiday Name and Date Fields -->
                <div class="row">
                    <!-- Holiday Name Field -->
                    <div class="col-sm-6">
                        <label class="form-label">Holiday Name</label>
                        <input type="text" class="form-control" placeholder="Enter Holiday Name"
                            [(ngModel)]="holiday.name" name="name" />
                    </div>

                    <!-- Holiday Date Field -->
                    <div class="col-sm-6">
                        <label class="form-label">Date</label>
                        <input type="date" class="form-control" placeholder="Select Date" [(ngModel)]="holiday.date"
                            name="date" />
                    </div>

                </div>
            </form>
        </nb-card-body>
    </nb-card>
</div>

<!-- Loading Spinner -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>